import { Box, CircularProgress } from "@mui/material";
import styles from "./SubscriptionSelectionStep.module.css";
import { SubscriptionSelectionStepProps } from "../../Utils/Types";

export default function SubscriptionSelectionStep({
  subscriptions,
  selectedSubscription,
  onSubscriptionSelect,
  loading = false,
}: SubscriptionSelectionStepProps) {
  if (loading) {
    return (
      <Box className={styles.loadingContainer}>
        <CircularProgress size={40} sx={{ marginBottom: "1rem" }} />
        <p className={styles.emptyStateText}>Se încarcă planuri...</p>
      </Box>
    );
  }

  if (subscriptions.length === 0) {
    return (
      <Box className={styles.emptyState}>
        <svg
          className={styles.emptyStateIcon}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p className={styles.emptyStateText}>
          Nu sunt planuri disponibile în acest moment
        </p>
      </Box>
    );
  }

  return (
    <div className={styles.container}>
      {subscriptions.map((subscription) => (
        <div
          key={subscription._id}
          className={`${styles.card} ${
            selectedSubscription?._id === subscription._id
              ? styles.cardSelected
              : ""
          }`}
          onClick={() => onSubscriptionSelect(subscription)}
        >
          {subscription.isPopular && (
            <div className={styles.popularBadge}>
              ⭐ Popular
            </div>
          )}

          <div className={styles.header}>
            <h3 className={styles.planName}>{subscription.name}</h3>
            <p className={styles.duration}>
              {subscription.durationInDays} zile
            </p>
          </div>

          <div className={styles.priceSection}>
            <div className={styles.price}>
              <span className={styles.currency}>
                {subscription.price.toFixed(2)}
              </span>
              <span className={styles.currencyUnit}>RON</span>
            </div>
          </div>

          <div className={styles.benefitsSection}>
            <p className={styles.benefitsTitle}>Incluse</p>
            <ul className={styles.benefitsList}>
              {subscription.benefits.map((benefit, idx) => (
                <li key={idx} className={styles.benefitItem}>
                  <div className={styles.checkmark}>
                    <svg
                      className={styles.checkmarkIcon}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span>{benefit.name}</span>
                </li>
              ))}
            </ul>
          </div>

          <button
            className={`${styles.selectButton} ${
              selectedSubscription?._id === subscription._id
                ? styles.selectButtonSelected
                : styles.selectButtonDefault
            }`}
          >
            {selectedSubscription?._id === subscription._id ? (
              <>
                <svg
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                Selectat
              </>
            ) : (
              "Selectează plan"
            )}
          </button>
        </div>
      ))}
    </div>
  );
}
